import { render, staticRenderFns } from "./testimonials_03.vue?vue&type=template&id=e54eea48&"
import script from "./testimonials_03.vue?vue&type=script&lang=js&"
export * from "./testimonials_03.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports